import { ApiService } from './api/api'

export default class DateService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	/**
	 * Get
	 * @param id string - collection number
	 * @param params Object
	 * @returns Promise
	 */
	getWorkingWeeks(date: string, weekends = false): Promise<any> {
		return this.apiService.get(`/working-weeks/${date}${weekends ? '?weekends=true' : ''}`)
	}
}
